import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";

import { diaVencimentoApi } from "./api";

/** Estado do dia de vencimento: o dia em vigor, a troca agendada e o mês em que
 *  uma troca nova passaria a valer. `trocar` grava e devolve o estado novo. */
export const useDiaVencimento = () => {
  const [dados, setDados] = useState(null);
  const [salvando, setSalvando] = useState(false);

  const carregar = useCallback(async () => {
    try {
      const r = await diaVencimentoApi.ver();
      setDados(r.data || null);
    } catch (_) {
      setDados(null);   // sem o bloco a tela de Assinatura segue funcionando
    }
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  const trocar = async (dia) => {
    setSalvando(true);
    try {
      const r = await diaVencimentoApi.trocar(dia);
      setDados(r.data || null);
      return true;
    } catch (e) {
      toast.error(e.response?.data?.detail || "Não foi possível trocar o dia de vencimento");
      return false;
    } finally {
      setSalvando(false);
    }
  };

  return { dados, salvando, trocar };
};
